<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import InboxesAPI from 'dashboard/api/inboxes';
import SettingsFieldSection from 'dashboard/components-next/Settings/SettingsFieldSection.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
});

const { t } = useI18n();
const store = useStore();
const isRegistering = ref(false);

const register = async () => {
  isRegistering.value = true;
  try {
    await InboxesAPI.registerBuzzerBridge(props.inbox.id);
    await store.dispatch('inboxes/get', props.inbox.id);
    useAlert(t('INBOX_MGMT.VOICE_CALLS.BRIDGE.REGISTER_SUCCESS'));
  } catch (error) {
    useAlert(
      error?.response?.data?.error ||
        t('INBOX_MGMT.VOICE_CALLS.BRIDGE.REGISTER_FAILED')
    );
  } finally {
    isRegistering.value = false;
  }
};
</script>

<template>
  <SettingsFieldSection
    :label="t('INBOX_MGMT.VOICE_CALLS.BRIDGE.STATUS_LABEL')"
    :help-text="t('INBOX_MGMT.VOICE_CALLS.BRIDGE.DESCRIPTION')"
  >
    <div class="flex flex-wrap items-center gap-3">
      <span
        class="inline-flex items-center gap-1.5 text-sm font-medium"
        :class="inbox.bridge_registered ? 'text-n-teal-11' : 'text-n-amber-11'"
      >
        <span
          class="size-2 rounded-full"
          :class="inbox.bridge_registered ? 'bg-n-teal-9' : 'bg-n-amber-9'"
        />
        {{
          inbox.bridge_registered
            ? t('INBOX_MGMT.VOICE_CALLS.BRIDGE.REGISTERED')
            : t('INBOX_MGMT.VOICE_CALLS.BRIDGE.NOT_REGISTERED')
        }}
      </span>
      <NextButton
        v-if="!inbox.bridge_registered"
        sm
        :is-loading="isRegistering"
        :label="t('INBOX_MGMT.VOICE_CALLS.BRIDGE.REGISTER')"
        @click="register"
      />
    </div>
  </SettingsFieldSection>
</template>
